<template>
  <div class="block-advice-wrapper w-full">
    <div class="flex items-center advice-content">
      <div
        class="advice-item"
        :class="{ active: adviceType === 'check' }"
        @click="clickExperienceAiCheck"
      >
        <i
          class="iconfont iconAIzhinengjiancha"
          style="margin-right: 4px"
        ></i>
        <span>智能检查</span>
      </div>
      <div
        class="advice-item"
        :class="{ active: adviceType === 'optimization' }"
        :disabled="!item.description"
        @click="clickExperienceAiOptimization"
      >
        <i
          class="iconfont icona-AIjianlirunse"
          style="margin-right: 4px"
        ></i>
        <span>简历润色</span>
      </div>
    </div>
    <ResumeOptimization
      v-show="adviceType === 'optimization'"
      :optimizationStatus="optimizationStatus"
      :optimizationResult="optimizationResult"
      :description="item.description"
      @buyMember="buyMember"
      @useOptimizationContent="useOptimizationContent($event, item)"
      @saveForm="saveExperience(item.id)"
      @closeOptimization="closeOptimization"
      @clickAiOptimization="clickAiOptimization(item)"
    />
    <CheckSuggestionList
      v-show="adviceType === 'check'"
      :list="suggestionList"
      style="padding-bottom: 18px;margin-top: 24px"
      @clickRepairIssue="resolveIssue(item, module)"
      @clickIgnore="clickIgnore($event, item, module)"
      @clickAiCheck="$emit('singleExperienceCheck', item, ['custom', 'skill_list'].includes(module) ? 'custom_sections' : module);"
    />
  </div>
</template>
<script>
import CheckSuggestionList from '../CheckSuggestionList/CheckSuggestionList.vue';
import ResumeOptimization from '../ResumeOptimization/ResumeOptimization.vue';
import { resumeOptimizationMixin } from '../../mixins/resume-optimization';

export default {
  name: 'EditorAdviceBlock',
  mixins: [resumeOptimizationMixin],
  components: {
    CheckSuggestionList,
    ResumeOptimization,
  },
  props: {
    module: {
      type: String,
      default: '',
    },
    item: {
      type: Object,
      default: () => ({}),
    },
    suggestionList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      adviceType: '',
    };
  },
  watch: {
    suggestionList(newVal) {
      if (newVal?.length) {
        this.changeAdviceType('check');
      } else {
        this.changeAdviceType('');
      }
    },
  },
  methods: {
    changeAdviceType(type) {
      this.adviceType = type;
    },
    clickExperienceAiCheck() {
      const hasSuggestion = this.suggestionList?.some((item) => item.status === 'not_answered' || item.status === 'answered');
      if (hasSuggestion) {
        this.changeAdviceType('check');
      } else {
        this.$emit('singleExperienceCheck', this.item, ['custom', 'skill_list'].includes(this.module) ? 'custom_sections' : this.module);
      }
    },
    clickExperienceAiOptimization() {
      if (!this.optimizationResult) {
        this.clickAiOptimization(this.item);
      } else {
        this.changeAdviceType('optimization');
      }
    },
    saveExperience(id) {
      this.$emit('saveExperience', id);
    },
    resolveIssue(item, module) {
      this.$emit('resolveIssue', item, ['custom', 'skill_list'].includes(this.module) ? 'custom_sections' : this.module);
    },
    clickIgnore(event, item, module) {
      this.$emit('clickIgnore', event, item, ['custom', 'skill_list'].includes(this.module) ? 'custom_sections' : this.module);
    },
    buyMember() {
      this.$emit('buyMember');
    },
    useOptimizationContent(content, item) {
      this.$emit('useOptimizationContent', content, item);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/variable.scss';
.block-advice-wrapper {
  background: linear-gradient(45deg, $advice-bg-start 0%, $advice-bg-middle 62%, $advice-bg-end 100%);
  border: 1px solid $advice-border-color;
  border-radius: 12px;
  padding: 6px 18px;

  .advice-content {
    padding: 12px 0;

    .advice-item {
      position: relative;
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      color: $advice-text-color;
      font-weight: 500;

      &:first-child::after {
        content: '';
        display: inline-block;
        position: absolute;
        right: 0;
        top: 0;
        width: 1px;
        height: 100%;
        background-color: $advice-border-color;
      }

      &.active {
        i,
        span {
          -webkit-text-fill-color: transparent;
          background: linear-gradient(180deg, #e15d3f 0%, #febf5d 100%);
          background-clip: text;
        }
        &::before {
          content: '';
          display: inline-block;
          position: absolute;
          left: 18px;
          bottom: -12px;
          width: calc(100% - 18px);
          height: 2px;
          background: linear-gradient( 270deg, #E15D3F 0%, #FEBF5D 100%);
        }
      }
    }
  }
}
</style>
